export default __webpack_public_path__ + "static/media/style7.cf42a54f.jpeg";